<p-toast></p-toast>
<div class="page-wrapper my-categories-page">
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div>
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Gestion > Mon catalogue
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="my-categories-page-inner">
      <div class="wrap-title d-flex align-items-center justify-content-between gap-2">
        <h2 class="title p-0 m-0">MON CATALOGUE</h2>
        <button *ngIf="userService.hasExtranetAccess('fonctions', 'gestion-articles')" (click)="saveListSuppliers()"
          class="btn-common btn-save">ENREGISTRER</button>
      </div>
      <p class="open-text mb-3">Filtrer l'ensemble du catalogue pour ses collaborateurs sur un ou plusieurs fournisseurs
      </p>
      <div class="mb-3 w-12" *ngIf="userService.hasExtranetAccess('fonctions', 'gestion-articles')">
        <div class="wrap-input">
          <label for="">Raison sociale</label>
          <input (focusout)="emptyList()" [(ngModel)]="searchSupplier" (keyup)="onSearchInput()"
            [ngModelOptions]="{standalone: true}" type="text" placeholder="Rechercher un fournisseur" />
          <div class="autocomplete-list" *ngIf="autocompleteSearchlistSuppliers.length > 0">
            <ul class="p-0" style="list-style: none">
              <li class="ac-li" *ngFor="let item of autocompleteSearchlistSuppliers" (click)="selectItem(item)">
                {{item.companyName}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="group-categories d-flex mb-5 flex-wrap">
        <div class="width-6" *ngFor="let item of listSuppliers">
          <div class="wrap-item">
            <button (click)="delItem(item)" class="btn-clear p-1">
              <img src="src-adisco/assets/images/icon/trash.svg" alt="">
            </button>
            <a>
              <img *ngIf="item?.logo && item?.logo[0]" class="mb-2" src="{{ item?.logo[0]?.url}}" alt="">
              <img *ngIf="!item?.logo || !item?.logo[0]?.url" class="mb-2"
                src="src-adisco/assets/images/image-default.jpeg" alt="">
              <p class="mb-0 text-center">{{ item?.companyName }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog header="Supprimer le fournisseur" [modal]="true" [(visible)]="visiblePopup" [style]="{ width: '600px' }">
  <div class="popup-del-acc">
    <p>Êtes-vous sûr de vouloir supprimer ces données ?</p>
    <div class="d-flex justify-content-end px-2">
      <button (click)="delItemInDB()" class="btn-common btn-save py-2">Supprimer</button>
    </div>
  </div>
</p-dialog>